import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const time = new Quantity(
    quantityId.TIME,
    'Time'
);

time.registerUnit(
    new Unit(
        's', 1, 'second', [
            's', '″'
        ]
    )
);

time.registerUnit(
    new Unit(
        'm', 60, 'second', [
            'm', '′'
        ]
    )
);

time.registerUnit(
    new Unit(
        'h', 3600, 'hour', [
            'h'
        ]
    )
);

export default time;